<h1 mat-dialog-title class="p-2 text-center">Export des mesures sur opérateurs par année</h1>
<div mat-dialog-content class="p-3">
  <div class="row">
    <mat-form-field class="col">
      <mat-select placeholder="Année" [(ngModel)]="SelectedYear" [compareWith]="compareWith" [disabled]="LoadingTask.IsLoading > 0">
        @for (u of YearList; track u; let i = $index) {
          <mat-option [value]="u">
            <span>{{u}} </span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="col">
      <mat-select placeholder="Mois" [(ngModel)]="SelectedMonth" [compareWith]="compareWith" [disabled]="LoadingTask.IsLoading > 0">
        @for (u of MonthList; track u; let i = $index) {
          <mat-option [value]="u">
            <span>{{getMonthLabel(u)}} </span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="row mt-3 g-0">
    <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
      Annuler
    </button>
    <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanAdd()">
      Exporter
    </button>
  </div>
</div>